<template>
  <div>
    <table class="table table-responsive">
      <tbody>
        <tr v-if="status">
          <th style="border-top: none">Status</th>
          <td style="border-top: none">
            <EpcStatus :status="status" />
          </td>
        </tr>
        <tr>
          <th>{{ $t('name') }}</th>
          <td>
            {{ saveGet(legalEntity, '-', 'organizationName', 0, 'value') }}
          </td>
        </tr>
        <tr>
          <th>{{ $t('parent_company') }}</th>
          <td>
            <template
              v-if="saveGet(legalEntity, false, 'parentOrganization', 'gln')"
            >
              {{ $t(`glnType.${glnType}_text`) }}
              <br />
              {{ saveGet(legalEntity, '-', 'parentOrganization', 'gln') }}
            </template>
            <template v-else> - </template>
          </td>
        </tr>
        <tr>
          <th>{{ $t('role') }}</th>
          <td>
            <ul style="padding-left: 0" id="v-roles-list">
              <p v-for="role in roles" :key="role.toString() + Math.random()">
                {{ $t(`locationType.${role}_title`) }}
              </p>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{ $t('more_organizations') }}</th>
          <td>
            <template
              v-if="additionalIDs instanceof Array && additionalIDs.length > 0"
            >
              <p
                v-for="additionalID in additionalIDs"
                :key="additionalID.toString() + Math.random()"
              >
                {{
                  $t(`locationIdType.${additionalID.locationID_Type}_title`)
                }}:
                {{ additionalID.locationID }}
              </p>
            </template>
            <template v-else> - </template>
          </td>
        </tr>
        <tr>
          <th>{{ $t('adress') }}</th>
          <td style="border-bottom: 0">
            <Address
              :show-map="showMap"
              :address="saveGet(legalEntity, null, 'address', 0)"
            />
          </td>
        </tr>
        <tr>
          <th>{{ $t('contact') }}</th>
          <td style="border-bottom: 0">
            <Contact :contact="saveGet(legalEntity, null, 'contactPoint', 0)" />
          </td>
        </tr>
        <links-tr :linkSet="linkSet">{{ $t('targets') }}</links-tr>
        <tr>
          <th>{{ $t('last_update') }}</th>
          <td style="border-bottom: none">{{ dateUpdated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { saveGet } from '../mixins/saveGet'
import Address from './Address'
import Contact from './Contact'
import moment from 'moment/moment'
import Gs1Alert from './alerts/Gs1Alert.vue'
import EpcStatus from './EpcStatus.vue'
import LinksTr from '@/components/LinksTr.vue'

export default {
  name: 'LegalEntity',
  props: ['legalEntity', 'showMap', 'status', 'linkSet'],
  components: {
    EpcStatus,
    Gs1Alert,
    Contact,
    Address,
    LinksTr
  },
  mixins: [saveGet],
  computed: {
    glnType() {
      return this.saveGet(
        this.legalEntity,
        '-',
        'parentOrganization',
        'glnType'
      )
    },
    roles() {
      return this.saveGetAndMap(
        this.legalEntity,
        '-',
        arr => arr.filter(x => x),
        'organizationRole'
      )
    },
    additionalIDs() {
      return this.saveGet(this.legalEntity, null, 'additionalOrganizationID')
    },
    dateUpdated() {
      let updated = this.saveGet(this.legalEntity, '', 'dateUpdated')
      if (!updated) {
        return '-'
      }
      return moment(updated).format('DD. MMM YYYY')
    }
  },
  i18n: {
    messages: {
      de: {
        name: 'Name',
        role: 'Unternehmensrolle',
        parent_company: 'GLN des Mutterunternehmen',
        contact: 'Kontakt',
        last_update: 'Zuletzt geändert',
        adress: 'Adresse',
        more_organizations: 'Weitere Unternehmens-IDs',
        targets: 'Lokationsbezogene Verlinkungen'
      },
      en: {
        name: 'Name',
        role: 'Company role',
        parent_company: ' Parentcompany GLN',
        contact: 'Contact',
        last_update: 'Last update',
        adress: 'Address',
        more_organizations: 'Additional organization-IDs',
        targets: 'Location related links'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LegalEntity.vue